import css from './event-detail.module.scss';
import {Onboard} from '../../components/onboard/onboard';
import {Button} from '../../components/button/button';
import {CSSProperties, useState} from 'react';
import {Paper} from '../../components/paper/paper';
import {EVENT_DETAIL} from './event-detail.mock';
import {useNavigate} from '@tanstack/react-location';
import {isMobile} from 'react-device-detect';
import {frameDimensions} from '../../shared/frame-dimensions';

export const EventDetail = (): JSX.Element => {
	const [imageHeight, setImageHeight] = useState<number>(0);
	const navigate = useNavigate();

	const onHeightSet = (onboardHeight: number) => {
		const margin = 80;
		const innerHeight = isMobile ? window.innerHeight : frameDimensions.height;
		setImageHeight(innerHeight - onboardHeight + margin);
	};

	const onClick = () => {
		navigate({to: '/setlist'});
	};

	const imageStyles: CSSProperties = {
		height: imageHeight,
		backgroundImage: 'url(/img/eventBg.png)',
	};

	const content = (
		<div className={css.content}>
			<div className={css.header}>
				<div className={css.name}>{EVENT_DETAIL.name}</div>
				<div className={css.datetime}>
					<img width={21} src="/img/dateTimeIconWhite.svg" />
					{EVENT_DETAIL.datetime}
				</div>
				<div className={css.placeAndDistance}>
					<img width={21} src="/img/locationIconWhite.svg" />
					<span className={css.city}>{EVENT_DETAIL.city}</span>
					<span className={css.distance}>{EVENT_DETAIL.distance}</span>
				</div>
				<ul className={css.stepsContainer}>
					<span className={css.bold}>STEPS:</span>
					<li>1. Add songs played during the show.</li>
					<li>2. Verify the setlist.</li>
					<li>3. Claim your reward!</li>
				</ul>
			</div>

			<Paper>
				🎁 <span className={css.bold}>Reward:</span> 2,000 (SetPay) SET Tokens
			</Paper>

			<div className={css.buttonContainer}>
				<Button onClick={onClick} name="Event Setlist" color="blue" />
			</div>
		</div>
	);

	return (
		<div className={css.container}>
			<div className={css.imageContainer} style={imageStyles} />
			<Onboard onHeightSet={onHeightSet}>{content}</Onboard>
		</div>
	);
};
